<template>
  <div class="pa-0">
    <ListLayout
      :title="integrationLogsModule.integrationLogPlural"
      :context="context"
      :tableData="tableData"
      :tableHeader="columnDefs"
      :total="totalItems"
      :hasAfterTitle="false"
      :hasListActions="true"
      @getList="onApplyFilter"
    >
      <template #listAction>
        <v-tabs height="31" v-model="tab" right class="pa-0 ma-0">
          <v-tab> {{ orderModule.orderPlural }} API </v-tab>
          <v-tab v-show="$helper.isCompanyHasItems()">
            {{ itemModule.itemPlural }} API
          </v-tab>
          <v-tab> {{ customerModule.customerPlural }} API </v-tab>
        </v-tabs>
      </template>
      <template #rightFilterSlot>
        <v-row no-gutters>
          <v-col cols="2" class="pr-4"></v-col>
          <v-col cols="5" class="pr-4">
            <SelectField
              id="status"
              name="status"
              label="Select Status"
              :itemsList="statusList"
              itemText="title"
              itemValue="value"
              v-model="filter.is_success"
              :dense="true"
              @change="onApplyFilter"
            />
          </v-col>
          <v-col cols="5" class="pr-4">
            <DatePicker
              id="start_date"
              name="start_date"
              label="Start Date"
              type="date"
              dense
              outlined
              clearable
              v-model="filter.date_filter"
              :max="currentDate"
              @input="onApplyFilter"
            />
          </v-col>
        </v-row>
      </template>
      <template #dialogs>
        <BaseDialog
          title="information"
          width="1200"
          v-model="openPayloadViewDialog"
          @reset="resetIntegrationData"
        >
          <template #information>
            <v-row class="pt-4">
              <v-col
                cols="3"
                v-for="(value, key, indexItem) of information"
                :key="indexItem"
                v-show="key != 'order_items' && key != 'address'"
              >
                <div v-if="key != 'order_items'">
                  <h3
                    class="primary--text text-uppercase font-weight-normal pb-2"
                  >
                    {{ key && key.replace(/_/g, "  ") }}
                  </h3>
                  <span class="primary--text font-weight-light text-body-1">
                    {{ value ? value : "-" }}
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row
              class="pt-4"
              v-if="
                information &&
                information.order_items &&
                information.order_items.length > 0
              "
            >
              <v-col cols="12">
                <h2 class="mt-2 mb-1">Order Items</h2>
              </v-col>
              <v-col cols="12">
                <v-row
                  v-for="(item, indexItem) in information.order_items"
                  :key="indexItem"
                  no-gutters
                >
                  <v-col
                    cols="3"
                    v-for="(value, key, indexItem) of item"
                    :key="indexItem"
                    class="pb-2"
                  >
                    <h4
                      class="primary--text text-uppercase font-weight-normal pb-1"
                    >
                      {{ key && key.replace(/_/g, "  ") }}
                    </h4>
                    <span class="primary--text font-weight-light text-body-2">
                      {{ value ? value : "-" }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row
              class="pt-4"
              v-if="
                information &&
                information.address &&
                Object.keys(information.address).length > 0
              "
            >
              <v-col cols="12">
                <h2 class="mt-2 mb-1">Addresses</h2>
              </v-col>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col
                    cols="3"
                    v-for="(subKey, subVal, subIndex) in information.address"
                    :key="subIndex"
                    class="pb-2"
                  >
                    <div>
                      <h4
                        class="primary--text text-uppercase font-weight-normal pb-1"
                      >
                        {{ subVal }}
                      </h4>
                      <span class="primary--text font-weight-light text-body-2">
                        {{ subKey ? subKey : "-" }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-2">
                    <hr style="opacity: 0.3" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </BaseDialog>
        <IntegrationAddItemForm
          ref="IntegrationAddItemForm"
          @refresh-item-logs-list="updateItemIntegration"
          v-model="showAddItemForm"
          :storageType="storageType"
        />
        <IntegrationAddCustomerForm
          ref="IntegrationAddCustomerForm"
          @refresh-customer-logs-list="updateCustomerIntegration"
          v-model="showAddCustomerForm"
          :branchList="branchList"
        />
        <!-- <IntegrationAddSalesDeliveryOrderForm
          ref="IntegrationAddSalesDeliveryOrderForm"
          @refresh-order-logs-list="updateOrderIntegration"
          v-model="showAddSalesDeliveryForm"
          :branchList="branchList"
          :itemList="itemList"
          :paymentMethodList="paymentMethodList"
          :currencyList="currencyList"
          :orderId="orderId"
          :orderType="orderType"
        ></IntegrationAddSalesDeliveryOrderForm> -->
        <IntegrationEditOrderDateForm
          ref="IntegrationAddSalesDeliveryOrderForm"
          @refresh-order-logs-list="updateOrderIntegration"
          v-model="showEditOrderDateForm"
          :branchList="branchList"
          :itemList="itemList"
          :paymentMethodList="paymentMethodList"
          :currencyList="currencyList"
          :orderId="orderId"
          :orderType="orderType"
        ></IntegrationEditOrderDateForm>
        <IntegrationDetailsLogs
          v-model="showItemLog"
          :integrationId="integrationId"
        ></IntegrationDetailsLogs>
      </template>
    </ListLayout>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import OrderIntegrationButton from "@/components/Button/OrderIntegrationButton.vue";
import ItemIntegrationButton from "@/components/Button/ItemIntegrationButton.vue";
import IntegrationErrors from "@/components/Button/IntegrationErrors.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import EmailNotification from "@/components/AgIcon/EmailNotification.vue";
import WhatsAppNotificationIcon from "@/components/AgIcon/WhatsAppNotificationIcon.vue";
import CustomerIntegrationButton from "@/components/Button/CustomerIntegrationButton.vue";
import IntegrationEditOrderDateForm from "@/components/ModuleBasedComponents/Integration/IntegrationEditOrderDateForm.vue";
import IntegrationAddItemForm from "@/components/ModuleBasedComponents/Integration/IntegrationAddItemForm.vue";
import IntegrationAddCustomerForm from "@/components/ModuleBasedComponents/Integration/IntegrationAddCustomerForm.vue";
import IntegrationAddSalesDeliveryOrderForm from "@/components/ModuleBasedComponents/Integration/IntegrationAddSalesDeliveryOrderForm.vue";
import IntegrationDetailsLogs from "@/components/ModuleBasedComponents/Integration/IntegrationDetailsLogs.vue";

import {
  integrationLogsModule,
  orderModule,
  itemModule,
  customerModule,
} from "@/utils/moduleMapping";

export default {
  components: {
    IntegrationDetailsLogs,
    IntegrationAddItemForm,
    IntegrationEditOrderDateForm,
    ListLayout,
    OrderIntegrationButton,
    ItemIntegrationButton,
    IntegrationErrors,
    BaseDialog,
    EmailNotification,
    WhatsAppNotificationIcon,
    CustomerIntegrationButton,
    IntegrationAddCustomerForm,
    IntegrationAddSalesDeliveryOrderForm,
  },
  data() {
    return {
      integrationLogsModule,
      orderModule,
      itemModule,
      customerModule,
      storageType: [],
      branchList: [],
      itemList: [],
      currencyList: [],
      paymentMethodList: [],
      currentDate: new Date().toISOString().slice(0, 10),
      filter: {
        start_date: new Date().toISOString().slice(0, 10),
      },
      customerList: [],
      customerAddressList: [],
      orderId: null,
      orderType: null,
      information: {},
      showAddItemForm: false,
      showAddCustomerForm: false,
      showAddSalesDeliveryForm: false,
      showEditOrderDateForm: false,
      date: null,
      search: null,
      tab: 0,
      statusList: [
        {
          title: "Success",
          value: true,
        },
        {
          title: "Failed",
          value: false,
        },
      ],
      openPayloadViewDialog: false,
      apiIntegrationType: "order_logs",
      itemsPerPage: 10,
      pageNo: 1,
      totalItems: 0,

      colDef: [
        {
          headerName: "",
          field: "error",
          minWidth: 80,
          maxWidth: 80,
          pinned: "left",
          cellRendererFramework: "IntegrationErrors",
        },
        {
          headerName: "Created On",
          field: "created",
          minWidth: 135,
       
        },
      ],
      tableData: [],
      showItemLog: false,
      integrationId: null,
    };
  },
  watch: {
    tab(val) {
      this.onApplyFilter();
    },
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    columnDefs() {
      if (this.tab == 0) {
        return [
          ...this.colDef,
          {
            headerName: "Reference Number",
            field: "reference_number",
            flex: 1,
            minWidth: 140,
          },
          {
            headerName: "Order Segment",
            field: "order_segment",
            flex: 1,
            minWidth: 100,
          },
          {
            headerName: "Order Type",
            field: "order_type",
            flex: 1,
            minWidth: 100,
          },
          {
            headerName: "Order date",
            field: "order_date",
            flex: 1,
            minWidth: 100,
          },
          {
            headerName: "branch",
            field: "branch_code",
            flex: 1,
            minWidth: 80,
          },
          {
            headerName: "total items",
            field: "total_order_items",
            flex: 1,
            hide: !this.$helper.isCompanyHasItems(),
            minWidth: 80,
          },
          {
            headerName: "Actions",
            width: 150,
            minWidth: 120,
            field: "actions",
            pinned: "right",
            cellRenderer: "OrderIntegrationButton",
          },
        ];
      }
      if (this.tab == 1) {
        return [
          ...this.colDef,
          {
            headerName: "Item No",
            field: "item_no",
            flex: 1,
            minWidth: 120,
          },
          {
            headerName: "Item Description",
            field: "description",
            flex: 1,
            minWidth: 180,
          },
          {
            headerName: "Storage Type",
            field: "storage_type",
            flex: 1,
            minWidth: 100,
          },
          {
            headerName: "volume",
            field: "volume",
            flex: 1,
            minWidth: 90,
          },
          {
            headerName: "weight",
            field: "weight",
            flex: 1,
            minWidth: 90,
          },
          {
            headerName: "Event",
            field: "event",
            minWidth: 90,
            flex: 1,
            hide: !this.$helper.isCompanyHasItems(),
          },
          {
            headerName: "Actions",
            field: "actions",
            pinned: "right",
            minWidth: 120,
            sortable: false,
            width: 150,
            cellRenderer: "ItemIntegrationButton",
          },
        ];
      }
      if (this.tab == 2) {
        return [
          ...this.colDef,

          {
            headerName: "Customer Code",
            field: "customer_code",
            sortable: false,
            pinned: "left",
            minWidth: 100,
          },
          {
            headerName: "Customer Name",
            field: "customer_name",
            sortable: false,
            pinned: "left",
            minWidth: 130,
          },
          {
            headerName: "branch",
            field: "branch_code",
            sortable: false,
          },

          {
            headerName: "Contact Number",
            field: "contact_number",
            sortable: false,
            minWidth: 120,
          },
          {
            headerName: "Contact Email",
            field: "contact_email",
            sortable: false,
            minWidth: 120,
          },
          {
            headerName: "Email Notification",
            field: "email_notification",
            cellRenderer: "EmailNotification",
            minWidth: 80,
          },
          {
            headerName: "WhatsApp Notification",
            field: "whatsapp_notification",
            cellRenderer: "WhatsAppNotificationIcon",
            minWidth: 80,
          },
          {
            headerName: "Event",
            field: "event",
            minWidth: 80,
            flex: 1,
            hide: !this.$helper.isCompanyHasItems(),
          },

          {
            headerName: "Actions",
            width: 150,
            minWidth: 120,
            field: "actions",
            pinned: "right",
            cellRenderer: "CustomerIntegrationButton",
          },
        ];
      }
    },
  },
  methods: {
    async getCurrencyList() {
      bus.$emit("showLoader", true);
      this.$api.currency
        .getCurrencyList({ limit: "all" })
        .then((res) => {
          this.currencyList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    updateItemIntegration(id) {
      this.tab = 1;
      this.$api.integration
        .successfullyItemIntegrationUpdated(id)
        .then(() => {
          this.getIntegrationItemList();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateOrderIntegration(id) {
      this.tab = 0;
      this.$api.integration
        .successfullyOrderIntegrationUpdated(id)
        .then(() => {
          this.getIntegrationOrderList();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateCustomerIntegration(id) {
      this.tab = 2;
      this.$api.integration
        .successfullyCustomerIntegrationUpdated(id)
        .then(() => {
          this.getIntegrationCustomerList();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async addIntegrationSalesDeliveryOrder(id, order_type) {
      await this.getBranchSelectList();
      await this.getItemSelectList();
      await this.getPaymentMethodList();
      await this.getCurrencyList();

      this.showEditOrderDateForm = true;
      this.orderId = id;
      if (order_type) {
        if (order_type.toString().toLowerCase() == "pickup") {
          this.orderType = "Pickup";
        } else {
          this.orderType = "Delivery";
        }
      }
      // this.$refs.IntegrationAddSalesDeliveryOrderForm.populateOrderIntegrationForm(
      //   id,
      //   order_type
      // );
      this.pageNo = 0;
    },
    async editOrderDate(id, order_type) {
      await this.getBranchSelectList();
      await this.getItemSelectList();
      await this.getPaymentMethodList();
      await this.getCurrencyList();

      this.showEditOrderDateForm = true;
      this.orderId = id;
      if (order_type) {
        if (order_type.toString().toLowerCase() == "pickup") {
          this.orderType = "Pickup";
        } else {
          this.orderType = "Delivery";
        }
      }
      // this.$refs.IntegrationAddSalesDeliveryOrderForm.populateOrderIntegrationForm(
      //   id,
      //   order_type
      // );
      this.pageNo = 0;
    },
    async addIntegrationCustomer(id) {
      await this.getBranchSelectList();
      this.showAddCustomerForm = true;
      this.$refs.IntegrationAddCustomerForm.populateCustomerIntegrationForm(id);
      this.pageNo = 2;
    },
    addIntegrationItem(id) {
      this.getStorageTypeSelectList();
      this.showAddItemForm = true;
      this.$refs.IntegrationAddItemForm.populateItemIntegrationForm(id);
      this.pageNo = 1;
    },
    viewIntegrationItemLogs(id) {
      this.showItemLog = true;
      this.integrationId = id;
    },
    async getPaymentMethodList() {
      return this.$api.paymentMethod
        .getPaymentMethodSelectList({ limit: "all" })
        .then((res) => {
          this.paymentMethodList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getItemSelectList() {
      bus.$emit("showLoader", true);
      this.$api.item
        .getItemSelectList({
          limit: "all",
        })
        .then((res) => {
          this.itemList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    async getBranchSelectList() {
      bus.$emit("showLoader", true);
      this.$api.branch
        .getBranchSelectList({
          limit: "all",
        })
        .then((res) => {
          this.branchList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    getStorageTypeSelectList() {
      bus.$emit("showLoader", true);
      return this.$api.storageType
        .getStorageTypeSelectList({ limit: "all" })
        .then((res) => {
          this.storageType = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    resetIntegrationData() {
      this.information = {};
      this.openPayloadViewDialog = false;
    },
    viewPayload(id) {
      if (this.tab == 0) {
        this.getIntegrationOrderDetails(id);
      } else if (this.tab == 1) {
        this.getIntegrationItemDetails(id);
      } else if (this.tab == 2) {
        this.getIntegrationCustomerDetails(id);
      }

      this.openPayloadViewDialog = true;
    },
    getIntegrationItemDetails(id) {
      this.$api.integration
        .getIntegrationItemDetails(id)
        .then((res) => {
          this.information = res.data.payload;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getIntegrationItemList(params = {}) {
      params = {
        ...params,
        ...this.filter,
      };
      bus.$emit("showLoader", true);
      this.$api.integration
        .getIntegrationItemList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tableData = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.log(err);
        });
    },
    getIntegrationCustomerDetails(id) {
      this.$api.integration
        .getIntegrationCustomerDetails(id)
        .then((res) => {
          this.information = res.data.payload;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getIntegrationCustomerList(params = {}) {
      params = {
        ...params,
        ...this.filter,
      };
      bus.$emit("showLoader", true);
      this.$api.integration
        .getIntegrationCustomerList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tableData = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.log(err);
        });
    },
    getIntegrationOrderDetails(id) {
      this.$api.integration
        .getIntegrationOrderDetails(id)
        .then((res) => {
          this.information = res.data.payload;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getIntegrationOrderList(params = {}) {
      params = {
        ...params,
        ...this.filter,
      };
      bus.$emit("showLoader", true);
      this.$api.integration
        .getIntegrationOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.tableData = res.data;
          this.totalItems = res.count;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.log(err);
        });
    },
    onApplyFilter(params) {
      this.pageNo = 1;
      params = {
        limit: this.$globalConstant.itemsPerPage,
        offset: 0,
        ...params,
      };
      if (this.tab == 0) {
        this.getIntegrationOrderList(params);
      } else if (this.tab == 1) {
        this.getIntegrationItemList(params);
      } else {
        this.getIntegrationCustomerList(params);
      }
      this.pageNo = 1;
    },
  },
};
</script>
